<template>
  <h6>DRV Fallmanagement</h6>
  <div class="table-responsive overflow-auto">
    <table id="dataTable1" class="table table-striped">
      <thead>
      <tr>
        <th>Status</th>
        <th>Office</th>
        <th>Start</th>
        <th>Ende</th>
        <th>Stand</th>
        <th>Stand %</th>
        <th>Coach 1</th>
        <th>UE Coach 1</th>
        <th>Coach 2</th>
        <th>UE Coach 2</th>
        <th>Letzter Termin</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="coaching in caseManagementCoachingList" :key="coaching.id">
        <td>{{ coaching.statusTranslation }}</td>
        <td>{{ coaching?.unemployed?.location?.name }}</td>
        <td>{{ coaching?.startDate }}</td>
        <td>{{ coaching?.startDate }}</td>
        <td>{{ coaching?.unitsDoneString }}</td>
        <td>{{ coaching?.unitsDonePercent }} %</td>
        <td>{{ coaching.coach1?.firstName }} {{ coaching.coach1?.lastName }}</td>
        <td>{{ coaching?.unitsDoneCoach1 }}</td>
        <td>{{ coaching.coach2?.firstName }} {{ coaching.coach2?.lastName }}</td>
        <td>{{ coaching?.unitsDoneCoach2 }}</td>
        <td>{{ coaching?.lastUnit }}</td>
        <td>
          <router-link
              :to="{
                  name: 'analyticsUnemployedDetailsOverviewCoachingDetails',
                  params: {
                    coachingType: 'case-management-coaching',
                    id: coaching.id
                  }
                }"
              class="btn btn-primary">
            Analytik
          </router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  caseManagementCoachingList: {
    require: true,
  },
});
</script>

<style scoped>

</style>